<template>
  <div class="my-order" ref="container">
    <div class="header bg-color-red">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="name">扫码收款</div>
        </div>
        <div class="pictrue"><img src="@assets/images/orderTime.png" /></div>
	  </div>
    </div>
    <div>
		<div class="amount-wapper">
			<div class="amount-title">收款金额</div>
			<div class="amount-input">
				<span>¥</span>
				<input type="number" v-model="amount_price" autofocus="autofocus" ref="input" placeholder="请输入收款金额" />
			</div>
		</div>
	</div>
	<div class="btn-wapper">
		<div class="collection-btn btn1" @click="openQRCode(1)">图书扫码</div>
		<div class="collection-btn btn2" @click="openQRCode(2)">视频扫码</div>
	</div>
	<div class="view-list" @click="$router.replace({ path: '/user/collection_list/999' })">
		前往查看收款列表<span class="iconfont icon-jiantou"></span>
	</div>
  </div>
</template>
<script>
import { postScanCollection, postCreateQrcode } from "@api/order";
import Loading from "@components/Loading";
import { mapGetters } from "vuex";
import {  parseQuery } from "@utils";
import { wechatEvevt } from "@libs/wechat";
import Vue from "vue";
import cookie from "@utils/store/cookie";

 
const NAME = "Collection";

export default {
  name: NAME,
  data() {
    return {
	  amount_price: '',
	  verify_code: '',
	  order_id: '',
	  timem: 5000
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) {
        this.amount_price = '';
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
		this.$refs.input.focus();
	})
  },
  methods: {
	//扫码
	openQRCode: function(type) {
	  let that = this;
	  if(!that.amount_price) return that.$dialog.toast({ mes: '请输入收款金额' });
	  wechatEvevt("scanQRCode", {
	    needResult: 1,// 默认为0，扫描结果由微信处理，1则直接返回扫描结果
	    onlyFromCamera: false,
		scanType: ["qrCode", "barCode"]// 可以指定扫二维码还是一维码，默认二者都有
	  }).then(res => {
		  var scanData = res;
		  postCreateQrcode({
			type: type,
		  	money: that.amount_price
		  }).then(res => {
		  	that.order_id = res.data.result.order_id;
			if (scanData.resultStr) {
				console.log('res.resultStr='+scanData.resultStr);
				if(scanData.resultStr.includes(',')){
					that.verify_code = scanData.resultStr.split(',')[1];        
				}else{
					that.verify_code = scanData.resultStr;
				}
				that.scanCollection(type);
			} else that.$dialog.error("没有扫描到什么！");
		  }).catch(err => {
		  	that.$dialog.error(err.msg);
		  });
	      
	  }).catch(res => {
	      console.log('catch='+res.is_ready);
	      if (res.is_ready) {
	        res.wx.scanQRCode({
	          needResult: 1,
	          onlyFromCamera: false,
	          success: function(res) {
				var scanData = res;
				 console.log('catch res.resultStr='+res.resultStr);
				postCreateQrcode({
					type: type,
					money: that.amount_price
				}).then(res => {
					that.order_id = res.data.result.order_id;
					if (scanData.resultStr) {
					  if(scanData.resultStr.includes(',')){
					    that.verify_code = scanData.resultStr.split(',')[1];        
					  }else{
					  	that.verify_code = scanData.resultStr;
					  }
					  that.scanCollection(type);
					} else that.$dialog.error("没有扫描到什么！");
				}).catch(err => {
					that.$dialog.error(err.msg);
				});
	          },
	          fail: function(res) {
				console.log('fail'+res.is_ready);
				console.log('fail_errMsg'+res.errMsg);
	            if (res.errMsg == "scanQRCode:permission denied") {
	              that.$dialog.error("没有权限");
	            }
	          }
	        });
	      }
	  });
	},
	//扫码收款 type=1图书扫码 type=2视屏扫码 
	scanCollection(type,ali=0){
		let that = this;
		if (!that.order_id) return this.$dialog.error("请重新扫描收款码");
		if (!that.verify_code) return this.$dialog.error("请扫描收款码");
		postScanCollection({
			money: that.amount_price,
			order_id: that.order_id,
			verify_code: that.verify_code,
			ali: ali
		}).then(res => {
			if(res.status == 200){
				switch(res.data.status){
				  case 'SUCCESS':
				  that.amount_price = '';
				  that.$dialog.loading.close();
				  that.timem = 5000;
				  that.$router.push('/user/collection/success' + '?type=' + res.data.result.type + '&money=' + res.data.result.money);
				  break;
				  case 'PAY_ERROR':
				  that.$dialog.loading.close();
				  that.timem = 5000;
				  that.$dialog.toast({
					  mes: res.msg,
					  time: 5000
				  });
				  setTimeout(function(){
					  that.openQRCode(type);
				  },1000)
				  break;
				  case 'PAY_LOOP':
				  if(that.timem == 5000){
					that.$dialog.loading.open("支付中，请勿关闭此页面");
				  }
				  setTimeout(function(){
					that.timem += 100;
					that.scanCollection(type);
				  },that.timem)
				  break;
				  case 'PAY_LOOP_ALI':
				  if(that.timem == 5000){
				  	that.$dialog.loading.open("支付中，请勿关闭此页面");
				  }
				  setTimeout(function(){
					that.timem += 100;
					that.scanCollection(type,1);
				  },that.timem)
				  break;
				}
			}
		}).catch(err => {
			that.$dialog.error(err.msg);
		});
	},
  }
};
</script>

<style scoped>
.amount-wapper{
	margin-top: 0.2rem;
	padding: 0 0.2rem;
}
.amount-title{
	color: #777;
}
.amount-input{
	display: flex;
	justify-content: left;
	align-items: center;
	margin-top: 0.1rem;
}
.amount-input span{
	font-size: 0.4rem;
	font-weight: bold;
}
.amount-input input{
	padding: 0 0.1rem;
	font-size: 0.6rem;
	font-weight: bold;
}
.btn-wapper{
	padding: 0.2rem 0;
	margin: 0 auto;
	display: flex;
	justify-content: space-around;
	align-items: center;
	margin-top: 50%;
}
.collection-btn{
	border-radius: 5px;
	padding: 0.2rem 0.7rem;
}
.btn2{
	color: #fff;
	background-color: #e93323;
}
.btn1{
	border: 1px solid #e93323;
	color: #e93323;
}
input::placeholder{
	font-size: 0.32rem;
	font-weight: normal;
	color: #ccc;
}
.view-list{
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #e93323;
	position: fixed;
	bottom: 0.5rem;
}
.view-list .iconfont{
	font-size: 0.2rem;
}
</style>
